import { render, staticRenderFns } from "./FormTitle.component.vue?vue&type=template&id=302f4f48"
var script = {}
import style0 from "./FormTitle.component.vue?vue&type=style&index=0&id=302f4f48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports